export default "../../../static/plugins/visualizations/nora/static/assets/fontawesome-webfont.32400f4e08932a94d8bfd2422702c446.eot";